import script from "./DisableVPN.vue?vue&type=script&setup=true&lang=js"
export * from "./DisableVPN.vue?vue&type=script&setup=true&lang=js"

import "./DisableVPN.vue?vue&type=style&index=0&id=267a999e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-267a999e"]])

export default __exports__